import React, { Fragment, useEffect, forwardRef, useContext } from "react";
import { DialogTitle, DialogContent, Dialog } from "@mui/material";
import { Grid, FormControl, DialogActions } from "@mui/material";
import { Button, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import _ from "lodash";
import Loader from "../common/Loader";
import ProjectContext from "../../context/project/ProjectContext";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function AddIntelliFiberClients(props: {
  showDialog: boolean;
  selectedClientUser: any;
  handleClose: Function;
  refresh: Function;
}) {
  const [open, setOpen] = React.useState(props.showDialog);
  const [newUser, setNewUser] = React.useState<any>({
    ClientName: "",
    Description: "",
  });
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState({ type: "", msg: "" });

  let { loading, clientUserList, createClient, updateClient } =
    useContext(ProjectContext);

  const handleClose = () => {
    console.log("close");
    props.handleClose();
    setOpen(false);
  };

  const disableUpdate = () => {
    // console.log("disableUpdate ", props.selectedClientUser, newUser);
    if (newUser.ClientName !== "" && newUser.Description !== "") {
      return _.isEqual(props.selectedClientUser, newUser);
    } else {
      return true;
    }
  };

  const disableAdd = () => {
    // console.log("disableAdd ", newUser);
    if (newUser.ClientName !== "" && newUser.Description !== "") {
      return false;
    } else {
      return true;
    }
  };

  const updateClientUser = async () => {
    // console.log("updateClientUser props", newUser);
    if (clientUserList && updateClient) {
      let isExist = clientUserList.find(
        (ele) =>
          ele.ClientName === newUser.ClientName &&
          ele.ClientID !== newUser.ClientID
      );
      if (isExist) {
        setAlertMsg({ type: "Warning", msg: "Client already exists" });
        setShowAlert(true);
        return;
      }
      try {
        let payload = {
          ClientName: newUser.ClientName,
          Description: newUser.Description,
          ClientID: newUser.ClientID,
        };
        const res = await updateClient(payload);
        // console.log("updateClientUser res", res);
        if (res) {
          setAlertMsg({ type: "Success", msg: "Client successfully updated" });
          setShowAlert(true);
          setNewUser({
            ClientName: "",
            Description: "",
          });
          props.refresh();
        }
      } catch (error) {
        console.log("updateClientUser err", error);
        setAlertMsg({ type: "Error", msg: "Unexpected error" });
        setShowAlert(true);
      }
    }
  };

  const closeAlert = () => {
    if (alertMsg.type === "Success") {
      props.handleClose();
    }
    setAlertMsg({ type: "", msg: "" });
    setShowAlert(false);
  };

  const createClientUser = async () => {
    // console.log("createClientUser props", newUser);
    if (clientUserList && createClient) {
      let isExist = clientUserList.find(
        (ele) => ele.ClientName === newUser.ClientName
      );
      if (isExist) {
        setAlertMsg({ type: "Warning", msg: "Client already exists" });
        setShowAlert(true);
        return;
      }

      try {
        let payload = {
          ClientName: newUser.ClientName,
          Description: newUser.Description,
        };
        const res = await createClient(payload);
        if (res) {
          setAlertMsg({ type: "Success", msg: "Client successfully created" });
          setShowAlert(true);
          props.refresh();
        }
      } catch (error) {
        console.log("createClientUser err", error);
        setAlertMsg({ type: "Error", msg: "Unexpected error" });
        setShowAlert(true);
      }
    }
  };

  const handleChange = (e: any) => {
    // console.log("handleChange", e.target.value);
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    // console.log("Existing user", props.selectedClientUser);
    if (props.selectedClientUser) {
      setNewUser(props.selectedClientUser);
    }
  }, [props.selectedClientUser]);

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <DialogTitle
          sx={{
            padding: "0.5rem 2rem",
            fontSize: "1rem",
            background: "#f1f2f6",
            fontWeight: "600",
          }}
        >
          {props.selectedClientUser ? "Edit Client" : "Add Client"}
        </DialogTitle>
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 0,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent style={{ padding: "2rem" }}>
          <Grid
            spacing={2}
            container
            direction="column"
            justifyContent="center"
            alignItems="stretch"
          >
            <Grid item sx={{ width: "100%" }} xs={12} sm={12}>
              <FormControl required fullWidth sx={{ m: 1 }}>
                <TextField
                  variant="outlined"
                  label="Client Name"
                  name="ClientName"
                  value={newUser.ClientName}
                  onChange={handleChange}
                />
              </FormControl>
            </Grid>
            <Grid item sx={{ width: "100%" }} xs={12} sm={12}>
              <FormControl required fullWidth sx={{ m: 1 }}>
                <TextField
                  multiline
                  rows={4}
                  variant="outlined"
                  label="Client Description"
                  name="Description"
                  value={newUser.Description}
                  onChange={handleChange}
                />
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions style={{ padding: "2rem" }}>
          <Button onClick={handleClose}>CANCEL</Button>
          {props.selectedClientUser ? (
            <Button
              variant="contained"
              onClick={updateClientUser}
              disabled={disableUpdate()}
            >
              Update
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={createClientUser}
              disabled={disableAdd()}
            >
              Add
            </Button>
          )}
        </DialogActions>

        {loading ? (
          <Grid container justifyContent="center" alignItems="center">
            <Loader />
          </Grid>
        ) : null}
      </Dialog>
      {/* Alert Dialog */}
      <Dialog open={showAlert}>
        <DialogTitle>{alertMsg.type}</DialogTitle>
        <DialogContent>{alertMsg.msg}</DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={closeAlert}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

export default AddIntelliFiberClients;
